module.exports = __webpack_public_path__ + "static/media/bench_press-01.72bc1ac5.png";